import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements OnChanges {

  @Output() closeDrawer: EventEmitter<any> = new EventEmitter();
  @Output() callback: EventEmitter<boolean> = new EventEmitter();

  @Input() title: string = "";
  @Input() showDrawer: boolean = false;
  @Input() confirmButton: string = "";

  private readonly delay: number = 200;
  protected isOpenDrawer: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    let showDrawer = changes["showDrawer"]?.currentValue;
    setTimeout(() => this.isOpenDrawer = showDrawer, this.delay)

  }

  closeDialog(isShowcaseCreated?: boolean): void {
    this.isOpenDrawer = false;
    setTimeout(() => this.closeDrawer.emit(isShowcaseCreated), this.delay)
  }

}
